import type { IpMetric, Month } from "./types";
import { STATS } from "@/lib/constants";

export const IP_METRICS: IpMetric[] = [
  {
    label: "Detection Rate",
    residential: { value: "0.3%", score: 3 },
    datacenter: { value: "97.8%", score: 98 },
    lowerIsBetter: true,
  },
  {
    label: "Trust Score",
    residential: { value: "9.7 / 10", score: 97 },
    datacenter: { value: "1.9 / 10", score: 19 },
    lowerIsBetter: false,
  },
  {
    label: "Success Rate",
    residential: { value: STATS.uptime, score: 99 },
    datacenter: { value: "42.3%", score: 42 },
    lowerIsBetter: false,
  },
  {
    label: "ISP Type",
    residential: { value: "Residential", score: 100 },
    datacenter: { value: "Cloud Host", score: 15 },
    lowerIsBetter: false,
  },
];

export const MONTHS: Month[] = [
  { label: "Jan", purchased: 100, used: 62, rollover: 0 },
  { label: "Feb", purchased: 100, used: 47, rollover: 38 },
  { label: "Mar", purchased: 100, used: 91, rollover: 91 },
  { label: "Apr", purchased: 100, used: 55, rollover: 100 },
];
